import { useEffect, useState } from "react";
import { CiCirclePlus } from "react-icons/ci";
import nodatafound from "../../../../../Assets/Icons/NoDataCard2.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchRpmAlertsList } from "../../../../../Redux/actions/rpmActions";
import { DatePicker, Flex, Modal, Spin } from "antd";
import AlertsTable from "./alertsTable";
import NewAlert from "./newAlert";
import AlertsFilter from "./alertsFilter";
import dayjs from "dayjs";
import { FaFilter } from "react-icons/fa";

function Index() {
  const [currentPage, setCurrentPage] = useState(1);
  const [newAlertMod, setNewAlertMod] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const { isLoading, alertsList, selectedRpmPatient } = useSelector(
    (state) => state.rpm
  );
  const dispatch = useDispatch();
  const { RangePicker } = DatePicker;

  useEffect(() => {
    const payload = {
      patientId: selectedRpmPatient.patientId,
      rpmApplicable: "Y",
      status: 1,
    };
    dispatch(fetchRpmAlertsList(payload));
  }, []);

  const handleNewModal = () => {
    setNewAlertMod(!newAlertMod);
  };

  const handleFilterModal = () => {
    setFilterModal(true);
  };

  const handleCloseFilter = () => {
    setFilterModal(false);
  };

  const handleDateRangeChange = (value) => {
    if (!value) return;

    const payload = {
      patientId: selectedRpmPatient.patientId,
      rpmApplicable: "Y",
      fromDate: dayjs(value[0]).format("MM/DD/YYYY"),
      toDate: dayjs(value[1]).format("MM/DD/YYYY"),
      status: 1,
    };
    dispatch(fetchRpmAlertsList(payload));
  };

  const handleClearFilter = () => {
    const payload = {
      patientId: selectedRpmPatient.patientId,
      rpmApplicable: "Y",
      status: 1,
    };
    dispatch(fetchRpmAlertsList(payload));
    setFilterModal(false);
  };

  return (
    <>
      <div>
        <div className="flex justify-between items-center py-3">
          <div className="">
            <h1 className="font-bold text-xl">Alert Data Review</h1>
          </div>
          <div className="flex gap-4">
            <div>
              <button
                onClick={handleNewModal}
                className="w-20 h-8 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md"
              >
                <span className="w-5 h-5">
                  <CiCirclePlus className="w-full text-[#189FAA] h-full" />
                </span>
                <span className="">New</span>
              </button>
            </div>
            <div>
              <div>
                {!filterModal && (
                  <button
                    onClick={handleFilterModal}
                    className="w-20 h-8 px-2 flex items-center rounded-md gap-2 bg-brand-primaryColor"
                  >
                    <span>
                      <FaFilter className="mr-1 text-white" />
                    </span>
                    <span className="text-white"> Filter</span>
                  </button>
                )}
                {filterModal && (
                  <RangePicker
                    allowClear={false}
                    onChange={handleDateRangeChange}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {filterModal && (
          <p
            className="flex items-center justify-end gap-2 text-brand-primaryColor cursor-pointer"
            onClick={handleClearFilter}
          >
            Clear All
          </p>
        )}
        <div
          className={`${
            isLoading === false && alertsList?.length === 0
              ? "w-full flex justify-center items-center"
              : "overflow-y-scroll h-[23rem] scrollWidth"
          }`}
        >
          {isLoading && alertsList?.length === 0 ? (
            <div className="flex items-center justify-center mt-[10%]">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          ) : alertsList?.length === 0 ? (
            <div className="flex flex-col items-center justify-center">
              <img
                src={nodatafound}
                alt="nodatafound"
                className="h-min w-min"
              />
              <p className="font-medium text-xl">No data found!!</p>
            </div>
          ) : (
            <div className="border">
              <AlertsTable
                data={alertsList}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalCount={alertsList?.length}
              />
            </div>
          )}
        </div>
      </div>

      {/* New Alert */}
      <Modal
        open={newAlertMod}
        onCancel={handleNewModal}
        footer={[]}
        destroyOnClose
      >
        <NewAlert handleClose={handleNewModal} />
      </Modal>

      {/* Filter */}
      <Modal title="Filter" onCancel={handleCloseFilter} footer={[]}>
        <AlertsFilter handleClose={handleCloseFilter} />
      </Modal>
    </>
  );
}

export default Index;
